import React from 'react';

import { GridColDef } from '@material-ui/data-grid';
import { Link } from 'react-router-dom';

import { renderDataGridCheckCell } from 'components/mui/DataGrid/DataGridCheckCell';
import { LoadedProfessional, LoadedUser } from 'core/backend';
import { IPlayerAccount } from 'core/playerAccount';
import { routeCreator } from 'services/routing';
import { GridColumn, renderDateCell } from 'utils/mui';

/**
 * The type of data in each table row.
 */
export type PlayerAccountTableRowData = IPlayerAccount & LoadedProfessional & LoadedUser;

const renderIdCell: GridColDef['renderCell'] = (params) => {
  const row = params.row as PlayerAccountTableRowData;

  return (
    <Link to={{ pathname: routeCreator.PlayerAccountDetail(row.id), state: row }}>{row.id}</Link>
  );
};

const renderUserCell: GridColDef['renderCell'] = (params) => {
  const row = params.row as PlayerAccountTableRowData;

  if (row.user === null) {
    return <>-</>;
  }

  return (
    <Link to={{ pathname: routeCreator.UserDetail(row.user.id), state: row.user }}>
      {row.user.name}
    </Link>
  );
};

const renderProfessionalCell: GridColDef['renderCell'] = (params) => {
  const row = params.row as PlayerAccountTableRowData;

  if (row.professional === null) {
    return <>-</>;
  }

  return (
    <Link
      to={{
        pathname: routeCreator.ProfessionalDetail(row.professional.id),
        state: row.professional,
      }}
    >
      {row.professional.name}
    </Link>
  );
};

export const playerAccountsTableColumns: GridColumn<PlayerAccountTableRowData>[] = [
  {
    field: 'id',
    headerName: '#',
    flex: 0.4,
    renderCell: renderIdCell,
    filterable: false,
  },
  {
    field: 'user',
    headerName: 'User',
    flex: 1,
    renderCell: renderUserCell,
    sortable: false,
  },
  {
    field: 'professional',
    headerName: 'Practice',
    flex: 1,
    renderCell: renderProfessionalCell,
    sortable: false,
  },
  {
    field: 'has_finished_introduction',
    headerName: 'Finished introduction',
    flex: 0.5,
    renderCell: renderDataGridCheckCell,
    filterable: false,
  },
  {
    field: 'last_brain_pattern_length',
    headerName: 'Last brain pattern length',
    flex: 0.75,
    filterable: false,
  },
  {
    field: 'brain_level',
    headerName: 'Brain level',
    flex: 0.5,
    filterable: false,
  },
  {
    field: 'nerve_level',
    headerName: 'Nerve level',
    flex: 0.5,
    filterable: false,
  },
  {
    field: 'nerve_highscore',
    headerName: 'Nerve highscore',
    flex: 0.5,
    filterable: false,
  },
  {
    field: 'created_at',
    headerName: 'Creation',
    flex: 0.5,
    renderCell: renderDateCell(),
    filterable: false,
  },
  {
    field: 'updated_at',
    headerName: 'Updated',
    flex: 0.5,
    renderCell: renderDateCell(),
    filterable: false,
  },
];
